module.exports = __webpack_public_path__ + "img/16.174b3214.png";